import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
  DialogService,
  IconName,
} from '@rp/shared/components';
import { of } from 'rxjs';

import { IHaveChanges } from '../models';

export const unsavedChangesGuard: CanDeactivateFn<IHaveChanges> = (component: IHaveChanges) => {
  const dialogService = inject(DialogService);

  if (!component.haveChanges()) {
    return of(true);
  }

  return dialogService
    .open(ConfirmationDialogComponent, {
      title: 'dialogs.unsavedChangesTitle',
      message: 'dialogs.unsavedChangesMessage',
      subMessage: 'dialogs.unsavedChangesSubMessage',
      confirmLabel: 'dialogs.quit',
      icon: IconName.InfoFill,
    } as ConfirmationDialogData)
    .afterClosed();
};
